import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import {
  MobileConsultationSectionsDto,
  UpdateMobileConsultationSectionsRequestDto,
} from '../../dtos/mobile-consultation-sections.dto';

@Injectable()
export class MobileConsultationSectionsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public get(organizationId: number): Observable<MobileConsultationSectionsDto> {
    return this.http.get<MobileConsultationSectionsDto>(
      `${this.apiUrl}${API_ENDPOINTS.mobileConsultationSettings.get(organizationId)}`,
    );
  }

  public update(
    organizationId: number,
    payload: UpdateMobileConsultationSectionsRequestDto,
  ): Observable<MobileConsultationSectionsDto> {
    return this.http.put<MobileConsultationSectionsDto>(
      `${this.apiUrl}${API_ENDPOINTS.mobileConsultationSettings.get(organizationId)}`,
      payload,
    );
  }
}
